"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconCheck = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M63.62 20.72a3.36 3.36 0 0 0 .31-4.52 3.22 3.22 0 0 0-4.74-.2L27.86 47.34 14.13 33.61a3.22 3.22 0 0 0-4.74.19 3.36 3.36 0 0 0 .32 4.52l15.53 15.53a3.7 3.7 0 0 0 5.24 0z"
  })),
  height: undefined,
  width: undefined
});
IconCheck.displayName = 'IconCheck';
var _default = IconCheck;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/check.js
// module id = 225
// module chunks = 0